import { useEffect, useMemo } from 'react';

export const useResetFiltersOnDefaultChange = (
  defaultFilters: any[],
  onResetFilters: () => void,
): void => {
  const serializedDefaultFilters = useMemo(
    () => JSON.stringify(defaultFilters),
    [defaultFilters],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onResetFilters, [serializedDefaultFilters]);
};
